import { useQuery } from '@tanstack/react-query'
import { ClientContractsService } from '../services'
import { APIContractClientDtoResponse } from '../types'
import { defaultQueryOptions } from './common'
import { TContractType } from '../types/general'

interface TOptions {
  enabled?: boolean
}

export const useClientContracts = (locationName: string, contractType?: TContractType, options?: TOptions) => {
  const defaultOptions = {
    enabled: !!locationName,
    ...options,
  }

  return useQuery<APIContractClientDtoResponse | null>({
    queryKey: ['clientContracts', locationName, contractType],
    queryFn: () => ClientContractsService.list(locationName, contractType),
    ...defaultQueryOptions,
    ...defaultOptions,
  })
}
